var _a;
import { theme } from '@chakra-ui/react';
const defaultOutline = (_a = theme.components.Button.variants) === null || _a === void 0 ? void 0 : _a.outline;
export const ButtonSizes = {
    lg: {
        fontSize: 'lg',
        h: 12,
        minW: 12,
        px: 6,
    },
    md: {
        fontSize: 'md',
        h: 10,
        minW: 10,
        px: 4,
    },
    sm: {
        fontSize: 'sm',
        h: 8,
        minW: 8,
        px: 3,
    },
    xs: {
        fontSize: 'xs',
        h: 6,
        minW: 6,
        px: 2,
    },
};
const Button = {
    baseStyle: (props) => ({
        // WCAG 2.4.7 Focus Visible: keyboard focus must show a visible ring on
        // every button. The css-reset strips outline/box-shadow for non-keyboard
        // focus (:focus:not([data-focus-visible-added])), so a mouse click keeps
        // the bgColor-only treatment below while keyboard focus draws this ring.
        // Both selectors cover native :focus-visible and the focus-visible polyfill.
        '&[data-focus-visible-added]': {
            outline: '2px solid',
            // The brand primary.500 (#32C0A0 default) is only ~2.3:1 on white and
            // fails the 1.4.11 focus-indicator threshold; a fixed dark ring is >=3:1
            // on any property brand colour. BENG-4171 #29.
            outlineColor: 'neutral.900',
            outlineOffset: '2px',
        },
        _focus: {
            bgColor: props.colorScheme == 'primary' ? 'primary.400' : 'neutral.100',
            boxShadow: 'none',
        },
        _focusVisible: {
            outline: '2px solid',
            // The brand primary.500 (#32C0A0 default) is only ~2.3:1 on white and
            // fails the 1.4.11 focus-indicator threshold; a fixed dark ring is >=3:1
            // on any property brand colour. BENG-4171 #29.
            outlineColor: 'neutral.900',
            outlineOffset: '2px',
        },
        border: 'none',
        cursor: 'pointer',
        fontFamily: 'var(--cb-title-text--font-family)',
    }),
    defaultProps: {},
    sizes: ButtonSizes,
    variants: {
        ghost: {
            _hover: {
                bgColor: 'neutral.100',
            },
        },
        link: {
            _focus: {
                bgColor: 'transparent',
            },
        },
        outline: (props) => (Object.assign(Object.assign({}, defaultOutline(props)), { _focus: {
                bgColor: 'white',
            }, _hover: {
                bgColor: 'neutral.100',
            }, bgColor: 'white', color: 'neutral.900' })),
    },
};
export default Button;
